const images = require('./images') ;
var Const = require ('Const');

const fonts = {
    Roboto: {
        normal: 'node_modules/roboto-font/fonts/Roboto/roboto-regular-webfont.ttf',
        bold: 'node_modules/roboto-font/fonts/Roboto/roboto-bold-webfont.ttf',
        italics: 'node_modules/roboto-font/fonts/Roboto/roboto-italic-webfont.ttf',
        bolditalics: 'node_modules/roboto-font/fonts/Roboto/roboto-bolditalic-webfont.ttf'
    }
};


const contentBody = ( student, fechaEgreso ) => {
// var cumple = student.persona.birthdate.substring(0,23) ;
var birthdate = new Date(student.persona.birthdate) ;

return (

{
    text:  [
        'La Dirección del establecimiento educativo',
        {text: ' Instituto Dr. Sallares', bold: true}, 
        ' DIEGEP ',
        {text: 'No 1957', bold: true}, 
        ' de C.U.E. Nº', 
        {text: ' 0608475-00', bold: true}, 
        ' ubicado en calle',
        {text: ' España 2912', bold: true}, 
        ' de la ciudad de',
        {text: ' Florencio Varela', bold: true}, 
        ', Provincia de Buenos Aires certifica' ,
        ' que ', 
        {text: student.persona.last_name.toUpperCase() + ' ' + student.persona.name.toUpperCase() , bold: true},
        ' nacido/a en ' ,
        student.persona.birth_place?student.persona.birth_place + ', ': '' ,
        ' el día ', 
        birthdate.getDate() ,
        ' del mes de ',
        Const.MONTHS[birthdate.getMonth()].toLowerCase() ,
        ' del año ' , 
        birthdate.getFullYear() ,
        ', tipo de Documento ',
        student.persona.doc_type,
        ' Nº ',
        student.persona.dniFormated, 
        ' ha concluido los estudios de Nivel Primario. \n\n',

        ' Diseño Curricular aprobado por Resolución 1482/17 - Dirección General De Cultura y',
        ' Educación de la Provincia de Buenos Aires \n', 
        {text: ' VALIDEZ NACIONAL', bold: true } ,
        ' otorgada por Resolución 2499/18 – Consejo Federal Educación \n\n',
        ' Fecha de egreso (RES 1872/20 - Comunicacioón 191/21 SSE - Comunicación Conjunta 06/21): ' , 
        fechaEgreso.getDate() ,
        ' de ',
        Const.MONTHS[fechaEgreso.getMonth()].toLowerCase() ,
        ' de ' , 
        fechaEgreso.getFullYear()  ,

        ' \n\n',
        'Otorgado en ',
        {text: 'Florencio Varela', bold: true},
        ' del distrito ', 
        {text: 'Florencio Varela', bold: true},
        ' Región ',
        {text: '4', bold: true},
        ' de la Provincia de Buenos Aires, \n',
    
        ' República Argentina a los ', 
        fechaEgreso.getDate() , 
        ' días del mes de ',
        Const.MONTHS[fechaEgreso.getMonth()],
        ' del año ',
        fechaEgreso.getFullYear()

    ]    
        , style: 'contenido', alignment: 'justify'
    
}
 
    )
} 
const header = ( student ) => {

return (
       [{
			text: [
                'Anexo Único ',
                student.persona.dniFormated,
                '/032'
            ], style: 'header', alignment: 'right'
	   } ,
        
       { image: images.escudo, height: 70, width: 44, alignment: 'center' },

	   {
			text: 'REPÚBLICA ARGENTINA', style: 'headerb'
	   } ,
	   {
			text: 'LEY DE EDUCACIÓN NACIONAL Nº 26.206', style: 'header'
	   } ,
	   {
			text: 'DIRECCIÓN GENERAL DE CULTURA Y EDUCACIÓN DE LA PROVINCIA DE BUENOS AIRES', style: 'headerb', 
	   } ,
	   {
			text: 'LEY DE EDUCACIÓN PROVINCIAL Nº 13.688', style: 'header', 
	   } ,
	   {
			text: 'DIRECCIÓN DE EDUCACIÓN DE GESTION PRIVADA', style: 'headerb'  
	   } 
    ] 
)
}


const footer =
    {
         text: '“La escuela secundaria es obligatoria” (Ley.13.688)', 
         style: 'footer' 
    };


const signatures = {
 
    		style: 'firmas',
            table: {
                    widths: [ '*', 10, '*', 10, '*' ],
                    body: [
                        [
                            {text:'', border: [false, true,false, false ]  },
                            {text:'', border: [false]  },
                            {text:'', border: [false, true,false, false ]  },
                            {text:'', border: [false  ]  },
                            {text:'', border: [false, true,false, false ]  }
                ],
                        [
                            {text:'Director del establecimiento', border: [false ] , alignment: 'center'   },
                            {text:'', border: [false]  },
                            {text:'Sello del Establecimiento', border: [false ], alignment: 'center'   },
                            {text:'', border: [false]  },
                            {text:'Inspector del Area',	border: [false ] , alignment: 'center' }
                ],
                    ]
                },
                layout: {
                    
                      paddingLeft: function (i) {
                        return i === 0 ? 10 : 8;
                      },
                      paddingRight: function (i, node) {
                        return (i === node.table.widths.length - 1) ? 10 : 8;
                      }
                }

    	};
        		 		 
/////
const styles = {
    header: {
        fontSize: 12,
        alignment: 'center'
    },
    headerb: {
        fontSize: 12,
        bold: true,
        alignment: 'center'
    } ,
    footer: {
        fontSize: 10,
        alignment: 'left'
    } ,
    firmas: { paddingRight: 10 ,
      border: [false ],
      margin: [0, 30, 0, 2],
    fontSize: 10,
    alignment: 'center'
  },
  contenido: {
    margin: [0, 30, 0, 15],
    lineHeight: 1.4,
  }
   

}


module.exports = {
  header, fonts, signatures, styles, footer, contentBody
};
